module.exports = __webpack_public_path__ + "img/appAsset-flag--CL.9fffa5fc.svg";